import React from "react";
import { useTranslation } from "react-i18next";
import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import PaymentsSection from './sections/PaymentsSection';
import { Route, Switch, useRouteMatch } from "react-router-dom";
import PaymentDetail from './pages/PaymentDetail';
import FinancialSettlementDetail from "./pages/FinancialSettlementDetail";

interface IProps {}

const Payments: React.FC<IProps> = (props) => {
  const { t } = useTranslation("shared\\moduleNames");
  let match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}/:id/financial-settlement`} component={FinancialSettlementDetail}/>
      <Route path={`${match.path}/:id`} component={PaymentDetail}/>
      <Route path={match.path}>
        <Header title={t("payments.title")} includeBreadcrumbs />
        <ModuleContent>
          <PaymentsSection />
        </ModuleContent>
      </Route>
    </Switch>
  );
};

export default Payments;